import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
// This import needs to be done before importing
// App as App import import the ApiService which try
// to get some window variables that wouldn't be
// loaded if this file is not imported.
import './tests/utils/setup';
import App from './components/App';
import '@olive/classic/dist/css/olive.min.css';
import './index.css';
import { AppTranslationProvider } from '@ds/react-utils';
import { TranslateFunction } from '@ds/base';
import { fetchTranslationFunction } from 'common';

const fetchTranslate = (lang: string): Promise<TranslateFunction> => {
    return fetchTranslationFunction(lang);
};

const rootElement = document.getElementById('root');

ReactDOM.render(
    <AppTranslationProvider fetchTranslate={fetchTranslate}>
        <App />
    </AppTranslationProvider>,
    rootElement
);
